// Generated file
package systems.frictionless.impulse.browser

object BuildConfig {
    const val GIT_SHA: String = "f8f66c2695e72e1775879d78b858e053055ac2ef"
    const val GIT_COMMIT_COUNT: Int = 949

    const val SENTRY_BROWSER_CONFIG: String = """{"api_key":"https://ee29b63815fa08f4a7ee1f45de255fc0@o4505918146347008.ingest.sentry.io/4506146833104896","project":"impulse-browser","environment":"production"}"""
}
